import React from 'react'
import { SkeletonAvatar, SkeletonCard, SkeletonText } from '@offerzen/pinata-shame'

import SceneLayout from '../../components/SceneLayout'

import styles from './styles'

/**
 * LoadingScene component
 *
 * @param {Object} props
 * @param {boolean} [props.showNav]
 *
 * @returns {JSX.Element}
 */
const LoadingScene = ({ showNav }) => (
  <SceneLayout showNav={showNav}>
    <p className={styles.accessiblyHidden}>Loading</p>
    <SkeletonCard className={styles.card}>
      <SkeletonAvatar size="extraLarge" theme="dark" />

      <div className={styles.content}>
        <SkeletonText theme="dark" width={100} />
        <SkeletonText theme="dark" width={120} />
        <SkeletonText theme="dark" width={170} />
        <SkeletonText theme="dark" width={130} />
        <SkeletonText theme="dark" width={80} />
      </div>
    </SkeletonCard>
  </SceneLayout>
)

export default LoadingScene
